import React, { useState } from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { Logo } from './ui/Logo';
import { LegalModal } from './ui/LegalModal';
import { TikTokIcon } from './ui/TikTokIcon';
import { useLanguage } from '../i18n/LanguageContext';
const TIKTOK_URL = 'https://www.tiktok.com/@riam_beautystudio?_r=1&_t=ZP-96pg2zAAtKw';
type LegalType = 'privacy' | 'terms' | null;
export function Footer() {
  const {
    t
  } = useLanguage();
  const [legalOpen, setLegalOpen] = useState<LegalType>(null);
  const currentYear = new Date().getFullYear();
  return <>
      <footer className="bg-riam-black py-16 border-t border-riam-gold/20" data-id="element-63">
        <div className="container mx-auto px-4 md:px-6 flex flex-col items-center text-center" data-id="element-64">
          <a href="#inicio" className="mb-8" data-id="element-65">
            <Logo size="lg" data-id="element-66" />
          </a>

          <p className="gold-shine-soft font-script text-2xl md:text-3xl max-w-2xl mb-10 leading-relaxed" data-id="element-67">
            {t.footer.quote_1}
            <span className="font-allura font-normal text-4xl md:text-5xl align-middle mx-1" data-id="element-68">
              {t.footer.quote_highlight}
            </span>
            {t.footer.quote_2}
            <br data-id="element-69" />
            <span className="mt-4 block text-riam-gold-dark" data-id="element-70">
              <span className="font-sans text-base align-middle mr-1" data-id="element-71">—</span>
              <span className="font-allura font-normal text-3xl md:text-4xl align-middle" data-id="element-72">
                {t.story.founder}
              </span>
            </span>
          </p>

          <div className="flex space-x-6 mb-10" data-id="element-73">
            <a href="https://www.instagram.com/riam_beautystudio/" target="_blank" rel="noreferrer" className="icon-glow hover:opacity-80 transition-opacity" aria-label="Instagram @riam_beautystudio" data-id="element-74">
              <Instagram size={24} stroke="url(#riamGold)" data-id="element-75" />
            </a>
            <a href="https://www.facebook.com/rosanaisabelanazcomartinez" target="_blank" rel="noreferrer" className="icon-glow hover:opacity-80 transition-opacity" aria-label="Facebook Rosana Isabel Añazco Martinez" data-id="element-76">
              <Facebook size={24} stroke="url(#riamGold)" data-id="element-77" />
            </a>
            <a href={TIKTOK_URL} target="_blank" rel="noreferrer" className="icon-glow hover:opacity-80 transition-opacity" aria-label="TikTok @riam_beautystudio" data-id="element-78">
              <TikTokIcon size={24} data-id="element-79" />
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-6 font-sans text-sm tracking-widest uppercase mb-10" data-id="element-80">
            <a href="#inicio" className="gold-shine hover:opacity-80 transition-opacity" data-id="element-81">
              {t.nav.inicio}
            </a>
            <a href="#galeria" className="gold-shine hover:opacity-80 transition-opacity" data-id="element-82">
              {t.nav.galeria}
            </a>
            <a href="#servicios" className="gold-shine hover:opacity-80 transition-opacity" data-id="element-83">
              {t.nav.servicios}
            </a>
            <a href="#historia" className="gold-shine hover:opacity-80 transition-opacity" data-id="element-84">
              {t.nav.historia}
            </a>
            <a href="#testimonios" className="gold-shine hover:opacity-80 transition-opacity" data-id="element-85">
              {t.nav.testimonios}
            </a>
            <a href="#contacto" className="gold-shine hover:opacity-80 transition-opacity" data-id="element-86">
              {t.nav.contacto}
            </a>
          </div>

          <div className="w-full h-px bg-riam-gold/10 mb-8 max-w-4xl" data-id="element-87"></div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 font-sans text-xs tracking-widest uppercase mb-4" data-id="element-88">
            <button type="button" onClick={() => setLegalOpen('privacy')} className="text-riam-gold-dark/80 hover:text-riam-gold-light transition-colors" data-id="element-89">
              {t.footer.privacy}
            </button>
            <span className="hidden md:inline text-riam-gold-dark/40" data-id="element-90">·</span>
            <button type="button" onClick={() => setLegalOpen('terms')} className="text-riam-gold-dark/80 hover:text-riam-gold-light transition-colors" data-id="element-91">
              {t.footer.terms}
            </button>
          </div>

          <p className="font-sans text-sm text-riam-gold-dark/60" data-id="element-92">
            Riam Beauty Studio © {currentYear} · Sunnyside, NY
          </p>
        </div>
      </footer>

      <LegalModal isOpen={legalOpen !== null} onClose={() => setLegalOpen(null)} type={legalOpen} data-id="element-93" />
    </>;
}